import React from "react";
import cn from "classnames";
import Cleave from "cleave.js/react";

const CleaveInput = (props) => {
  const {
    type,
    label,
    hideLabel,
    value,
    name,
    onChange,
    disabled,
    required,
    placeholder,
    onClick,
    lightFont,
    cleaveOptions,
    className,
    inputClassName,
    prefix,
    postfix,
    numericResult,
  } = props;

  const handleChange = (e) => {
    const { id, name, value } = e.target;
    console.log("CleaveInput", "handleChange", id, name, value);
    try {
      if (numericResult && value) {
        const parsedValue = parseFloat(value.replace(/,/g, ""));
        console.log("CleaveInput", "handleChange", id, name, value, parseFloat(value.replace(/,/g, "")));
        if (isNaN(parsedValue)) {
          return;
        }
        onChange({
          target: {
            id,
            name,
            value: parseFloat(value.replace(/,/g, "")),
          },
        });
        return;
      }
      onChange(e);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={cn("relative min-w-min", className)}>
      {!!prefix && (
        <span
          className={
            label
              ? "mt-5 absolute left-0 inset-y-0 ml-3 flex items-center leading-tight"
              : "absolute left-0 inset-y-0 ml-3 flex items-center leading-tight"
          }
        >
          {prefix}
        </span>
      )}
      <label htmlFor={name} className={cn({ "sr-only": hideLabel, "text-black": lightFont })}>
        {label}
      </label>
      <Cleave
        id={name}
        type={type}
        value={value ?? ""}
        name={name}
        onChange={handleChange}
        onClick={onClick}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        options={cleaveOptions}
        className={cn("h-9 px-1 border border-gray-300 rounded-md", inputClassName, {
          "mt-1": lightFont,
          "pl-6": !!prefix,
        })}
      />
      {!!postfix && (
        <span
          className={
            label
              ? "mt-5 absolute left-10 inset-y-0 ml-3 flex items-center leading-tight"
              : "absolute left-10 inset-y-0 ml-3 flex items-center leading-tight"
          }
        >
          {postfix}
        </span>
      )}
    </div>
  );
};

export default CleaveInput;
